// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"ca74f497","40":"68dcab47","59":"2dc494ae","66":"b2c33332","206":"620d81e9","499":"3bb35855","938":"b5f64cfc","940":"01a93175"}[chunkId] + ".css";
};